import { createContext, useContext, useMemo, useState } from 'react';

const Context = createContext();

export const useDeleteContext = () => useContext(Context);

export function Provider({ children }) {
  const [isConfirming, setConfirming] = useState(false);

  const state = useMemo(
    () => ({ isConfirming, setConfirming }),
    [isConfirming],
  );

  return <Context.Provider value={state}>{children}</Context.Provider>;
}
